(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('course', {
            parent: 'entity',
            url: '/course?page&sort&search',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.course.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/course/courses.html',
                    controller: 'CourseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('course');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('course-detail', {
            parent: 'entity',
            url: '/course/{id}',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.course.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/course/course-detail.html',
                    controller: 'CourseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('course');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Course', function($stateParams, Course) {
                    return Course.get({id : $stateParams.id});
                }]
            }
        })
        /*.state('course.new', {
            parent: 'course',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/course/course-dialog.html',
                    controller: 'CourseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('course', null, { reload: true });
                }, function() {
                    $state.go('course');
                });
            }]
        })*/
        .state('course.new', {
            parent: 'course',
            url: '/new',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.course.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/course/course-editor.html',
                    controller: 'CourseEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('course');
                    $translatePartialLoader.addPart('dayOfWeek');
                    $translatePartialLoader.addPart('amPm');
                    $translatePartialLoader.addPart('recommendationType');
                    return $translate.refresh();
                }],
                isCreateNew: function () {
                    return true;
                },
            }
        })
        .state('course.edit', {
            parent: 'course',
            url: '/:id/edit',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES], // ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.course.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/course/course-editor.html',
                    controller: 'CourseEditorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('course');
                    $translatePartialLoader.addPart('dayOfWeek');
                    $translatePartialLoader.addPart('amPm');
                    $translatePartialLoader.addPart('recommendationType');
                    return $translate.refresh();
                }],
                isCreateNew: function () {
                    return false;
                },
            }
        })
        /*.state('course.edit', {
            parent: 'course',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/course/course-dialog.html',
                    controller: 'CourseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Course', function(Course) {
                            return Course.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('course', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('course.delete', {
            parent: 'course',
            url: '/{id}/delete',
            data: {
                authorities: [constants.ROLE_DISABLE_WELLNESS_CLASSES] // ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/course/course-delete-dialog.html',
                    controller: 'CourseDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['Course', function(Course) {
                            return Course.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('course', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
